<app-header></app-header>
<section class="">
  <div class="container-fluid">
    <div class="cnss_report">
      <div class="reportTable">
        <div class="backarrow">
          <h4><i (click)="goBack()" class="fa-solid fa-angle-left"></i>{{'Family Allowance' | translate}}</h4>
        </div>
        <div>
          <div class="reason_for_reject" *ngIf="rejectReason && rejectReason.length >= 1 && employees.allowance_status==4">
            <div class="rejectNote reject_reasons" *ngFor="let item of rejectReason; let first = first" [ngClass]="{'hidden': !first && !showAll}">
              <div class="id-status">
                <img class="img-fluid" src="/assets/images/reject.png">
                <h5 class="m-0 align-self-center">{{'Rejected' | translate}}</h5>
              </div>
              <div class="d-flex">
                <h5>{{'Status2'| translate}}&nbsp;:&nbsp;
                </h5>
                <h6>{{'Rejected' | translate}}</h6>
              </div>
              <h5 class="text-capitalize">{{'Rejected by'| translate}} : {{item.rejected_by}}
              </h5>
              <h5>{{'Rejected on'| translate}} : {{item.rejected_on}}</h5>
              <h5 class="m-0">{{'Comments'| translate}} : {{item.rejected_comment}}</h5>
            </div>
          </div>
          <h3 *ngIf="rejectReason && rejectReason.length > 1" (click)="view()" id="view">{{'View more' | translate}}</h3>
        </div>
        <div class="overview">
          <div class="header" *ngIf="employees">
            <div class="logo-image">
              <img src="../../../assets/images/logoWithText.png" alt="">
              <p>CASSE NATIONALE <br> DE SECURITE SOCIALE</p>
            </div>
            <div class="center">
              <p class="text-center">{{'Application for family benefits' | translate}}</p>
            </div>
            <div class="date-section">
              <div class="d-flex w-100">
                <p>{{'Date of receipt' | translate}} : </p>
                <p class="text-dark">&nbsp;{{employees.date_of_receipt}}</p>
              </div>
              <div class="d-flex">
                <p class="text-right">{{"Employee’s CNSS number" | translate}} : </p>
                <p class="text-dark text-right">&nbsp;{{employees.cnss}}</p>
              </div>
            </div>
          </div>
          <div class="table_head">
            <h5>{{'Application for family benefits' | translate}}</h5>
          </div>
          <div class="container cnss_bg">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-12" *ngIf="employees">
                <ul class="sec1">
                  <li>
                    <h6 class="t1">{{'Name'| translate}}&nbsp;: </h6>
                    <h6>{{employees.employee_last_name}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{'First name'| translate}}&nbsp;: </h6>
                    <h6>{{employees.employee_first_name}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{'Mother name'| translate}}&nbsp;: </h6>
                    <h6>{{employees.mother_name}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{'Nationality'| translate}}&nbsp;: </h6>
                    <h6>{{employees.nationality}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{'Phone'| translate}}&nbsp;: </h6>
                    <h6>{{employees.mobile}}</h6>
                  </li>
                </ul>
              </div>
              <div class="col-lg-6 col-md-6 col-12" *ngIf="employees">
                <ul class="sec2">
                  <li>
                    <h6 class="t1">{{'Maiden name'| translate}}&nbsp;: </h6>
                    <h6>{{employees.maiden_name}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{'Father name'| translate}}&nbsp;:</h6>
                    <h6>{{employees.father_name}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{'Date of Birth'| translate}}&nbsp;:</h6>
                    <h6>{{employees.dob}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{'Postbox'| translate}}&nbsp;:</h6>
                    <h6>{{employees.post_box}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{'Email'| translate}}&nbsp;:</h6>
                    <h6>{{employees.email}}</h6>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="overview">
          <div class="table_head_1">
            <h5>{{'CERTIFICATE OF ATTENDANCE'| translate}}</h5>
            <h5 class="second-text">({{'to be completed by the employer' | translate}})</h5>
          </div>
          <div class="container cnss_bg">
            <div class="row">
              <div class="col-lg-6 col-md-6 col-12" *ngIf="employer">
                <ul class="sec1">
                  <li>
                    <h6 class="t1">{{"Company name"| translate}}&nbsp;:
                    </h6>
                    <h6>{{employer.company_name}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{"CNSS N° of company"| translate}}&nbsp;: </h6>
                    <h6>{{employer.company_cnss}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{"CNSS N° of employee"| translate}}&nbsp;: </h6>
                    <h6>{{employer.employee_cnss}}</h6>
                  </li>
                </ul>
              </div>
              <div class="col-lg-6 col-md-6 col-12" *ngIf="employer">
                <ul class="sec2">
                  <li>
                    <h6 class="t1">{{"Company address"| translate}}&nbsp;: </h6>
                    <h6>{{employer.business_location}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{"Employee's first and last name"| translate}}&nbsp;:</h6>
                    <h6>{{employer.employer_name}}</h6>
                  </li>
                  <li>
                    <h6 class="t1">{{"First date of hiring"| translate}}&nbsp;:
                    </h6>
                    <h6>{{employer.join_date}}</h6>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="table-container">
          <form>
            <table class="quarter_table">
              <caption>{{"INFORMATION CONCERNING THE OTHER PARENT"| translate}}</caption>
              <thead>
                <tr>
                  <th scope="col">{{'SL No' | translate}}</th>
                  <th scope="col">{{'Firstname and Lastname2'| translate}}</th>
                  <th scope="col">{{'Professional activities'| translate}}</th>
                  <th scope="col" colspan="2">{{"Registration number"| translate}}</th>
                  <th scope="col"></th>
                </tr>
                <tr>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                  <th scope="col">{{"CNSS"| translate}}</th>
                  <th scope="col">{{'CNAMGS'| translate}}</th>
                  <th scope="col">{{"CPPF"| translate}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of spouse; let key = index">
                  <td style="width: 5%;">{{key+1}}</td>
                  <td style="width: 20%;">{{item.Spourse_name}}</td>
                  <td style="width: 30%;">{{item.occupation}}</td>
                  <td style="width: 15%;">{{item.spouse_cnss_no}}</td>
                  <td style="width: 15%;">{{item.spouse_cnamgs_no}}</td>
                  <td style="width: 15%;">{{item.spouse_cppf_no}}</td>
                </tr>
              </tbody>
            </table>
          </form>
        </div>
        <div class="table-container">
          <form>
            <table class="quarter_table">
              <caption>{{'INFORMATION CONCERNING CHILDREN'| translate}}</caption>
              <thead>
                <tr>
                  <th scope="col">{{'SL No' | translate}}</th>
                  <th scope="col">{{'Firstname and Lastname3'| translate}}</th>
                  <th scope="col">{{'Birth date of child'| translate}}</th>
                  <th scope="col">{{"Full name of spouse"| translate}}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of child; let key = index">
                  <td>{{key+1}}</td>
                  <td>{{item.child_name}}</td>
                  <td>{{item.dob}}</td>
                  <td>{{item.Spourse_name}}</td>
                  <td>{{item.spouse_cppf_no}}</td>
                </tr>
              </tbody>
            </table>
          </form>
        </div>
        <div class="table-container" *ngIf="employees">
          <div class="made-section">
            <div class="d-flex">
              <p>{{'City of business' | translate}} :</p><span>&nbsp;{{employees.madein}}</span>
            </div>
            <div class="d-flex">
              <p>{{'Date of sending file' | translate}} : </p><span>&nbsp;{{employees.date_of_receipt}}</span>
            </div>
          </div>
        </div>
        <h4 class="text-left">{{'Signature' | translate}}</h4>
        <div class="signature-container my-5">
          <div [ngClass]="{'d-none': employees?.signature}">
            <canvas #canvas id="signature-pad" name="signaturevalue" value="" class="signature-pad" width=400 height=200></canvas>
            <div *ngIf="isSubmitted && signaturePad?.isEmpty() || isSubmitted && !signature" class="invalid-feedback mb-2 text-center">{{'Signature' | translate}} {{'is required'|translate}}
            </div>
            <div class="signature">
              <button class="btn-sm" (click)="saveImage()">{{'Save' | translate}}</button>
              <button class="btn-sm clear-btn" (click)="clearSignPad()">{{'Clear' | translate}}</button>
            </div>
          </div>
          <div *ngIf="signature && signature != null" class="image">
            <img src="{{signature}}">
          </div>
        </div>
        <div class="submition" *ngIf="value == 3 || value == 1 || employees?.allowance_status == 4">
          <button (click)="onSubmit()" type="submit" type="submit">{{'Submit' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal fade" id="familyAllowanceModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">{{'Generate family allowance'| translate}}</h5>
          <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" (click)="closeModal()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <form class="form-container" [formGroup]="familyAllowanceForm" (ngSubmit)="addFamilyAllowance()">
            <div class="parent">
<!--               <label for="">{{'Select Year'| translate}}</label>
              <select class="form-select form-select-lg mb-3" aria-label=".form-select-lg example" formControlName="year">
                <option value="2024" selected>2024</option>
              </select> -->
              <div class="input-container" [owlDateTimeTrigger]="dt49">
                <input class="custom-input text-center" name="year" readonly formControlName="year">
                <label for="">{{'Select Year'| translate}}</label>
                <div class="date-field">
                  <input [owlDateTime]="dt49" name="service_start_date" [min]="minReportDate" [max]="todayDate" readonly>
                  <div class="calendar input-group-prepend">
                    <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                  </div>
                </div>
                <owl-date-time [pickerType]="'calendar'" [startView]="'multi-years'" (yearSelected)="chosenYearHandler($event)" #dt49></owl-date-time>
              </div>
              <div *ngIf="rsubmitted && a.year.errors" class="invalid-feedback text-center">
                <div class="text-center" *ngIf="a.year.errors?.required">{{'Year is
                  required'|translate}}</div>
              </div>
              <button type="submit" id="submit_btn" class="btn btn-medium">{{'Generate'|
                translate}}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
<app-footer></app-footer>
<app-contact-floating></app-contact-floating>
